'use client';

// file imports
import { IQuestion } from '@/types';

interface QuestionHeaderProps {
  selectedQuestion: IQuestion | null;
  questions: IQuestion[];
  canAddCustomQuestions: boolean;
  onAddQuestion: () => void;
  getQuestionTypeLabel: (type: string) => string;
  showSaveButton?: boolean;
}

export default function QuestionHeader({ selectedQuestion, questions, canAddCustomQuestions, onAddQuestion, getQuestionTypeLabel, showSaveButton = true }: QuestionHeaderProps) {
  if (!showSaveButton) return null;

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">Question Type:</span>
          <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded font-medium">{selectedQuestion ? getQuestionTypeLabel(selectedQuestion.type) : 'Select a question'}</span>
        </div>
        <div className="flex items-center gap-3">
          {canAddCustomQuestions ? (
            questions.length >= 20 ? (
              <button className="flex items-center gap-2 px-3 py-2 bg-gray-400 text-white rounded-lg text-sm font-medium cursor-not-allowed" disabled title="You have reached the maximum limit of 20 questions">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add a question (20/20)
              </button>
            ) : (
              <button onClick={onAddQuestion} className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors cursor-pointer">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add a question ({questions.length}/20)
              </button>
            )
          ) : (
            <button className="flex items-center gap-2 px-3 py-2 bg-gray-400 text-white rounded-lg text-sm font-medium cursor-not-allowed" disabled title="Upgrade your plan to add custom questions">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Add a question
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
